(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["funnel-mb-llt-subscription-fb-my-strugle"] && !Shopify.designMode) return;
  try {
    
/* No JS needed (static section) */

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-cart"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', () => {
    // const handleIntersection = (entries, observer) => {
    //   if (!entries[0].isIntersecting) return;
  
    //   observer.unobserve(productRecommendationsSection);
  
    //   const url = productRecommendationsSection.dataset.url;
  
    //   fetch(url)
    //     .then(response => response.text())
    //     .then(text => {
    //       const html = document.createElement('div');
    //       html.innerHTML = text;
    //       const recommendations = html.querySelector('.product-recommendations');
  
    //       if (recommendations && recommendations.innerHTML.trim().length) {
    //         productRecommendationsSection.innerHTML = recommendations.innerHTML;
    //       }
    //     })
    //     .catch(e => {
    //       console.error(e);
    //     });
    // };
  
    // const productRecommendationsSection = document.querySelector('.product-recommendations');
    // if (productRecommendationsSection) {
    //   const observer = new IntersectionObserver(handleIntersection, {rootMargin: '0px 0px 200px 0px'});
    //   observer.observe(productRecommendationsSection);
    // }

    const applyDiscountButton = document.querySelector('#apply-discount-code');
    const discountInput = document.querySelector('#cart-discount');
    const errorMessage = document.querySelector('#discount-error-message');
    const cartPage = document.querySelector('cart-page');

    if (applyDiscountButton && discountInput) {
      const handleApplyDiscount = () => {
        const discountCode = discountInput.value.trim();
        
        if (!discountCode) {
          if (errorMessage) {
            errorMessage.textContent = 'Please enter a discount code';
            errorMessage.classList.remove('dr:hidden');
          }
          return;
        }

        if (errorMessage) {
          errorMessage.classList.add('dr:hidden');
        }

        applyDiscountButton.disabled = true;
        applyDiscountButton.textContent = 'APPLYING...';

        const sectionsToRender = window.HELPER_UTIL?.sectionRenderUtil('main-cart')?.getSectionsString() || 'main-cart';

        fetch(`${window.Shopify?.routes?.root || '/'}cart/update.js`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({ 
            discount: discountCode,
            sections: sectionsToRender
          })
        })
        .then(response => {
          if (!response.ok) {
            return response.json().then(err => Promise.reject(err));
          }
          return response.json();
        })
        .then(data => {
          if (cartPage && data.sections && window.HELPER_UTIL) {
            window.HELPER_UTIL.dispatchCustomEvent(
              'action:cart:updateCart',
              cartPage,
              { sections: data.sections }
            );
          } else {
            console.error('Failed to apply discount code');
          }
          discountInput.value = '';
          if (errorMessage) {
            errorMessage.classList.add('dr:hidden');
          }
        })
        .catch(error => {
          if (errorMessage) {
            errorMessage.textContent = error.description || error.message || 'Failed to apply discount code. Please try again.';
            errorMessage.classList.remove('dr:hidden');
          }
        })
        .finally(() => {
          applyDiscountButton.disabled = false;
          applyDiscountButton.textContent = 'APPLY';
        });
    };
  
      applyDiscountButton.addEventListener('click', handleApplyDiscount);
      
      discountInput.addEventListener('keypress', (e) => {
        if (e.key === 'Enter') {
          e.preventDefault();
          handleApplyDiscount();
        }
      });
    }
  });

  function renderCart(sectionId, responce) {
    console.log("renderCart", sectionId, responce);
    if(responce.items.length === 0) {
      window.scrollTo(0, 0);
      window.location.reload();
    }
    const cartSection = document.getElementById('cart-section');
    const blocksToRender = ['cart-items-container', 'cart-checkout-container', 'samples-products'];
    if (cartSection) {
      const tempDiv = document.createElement('div');
      tempDiv.innerHTML = responce.sections[sectionId];
      const newCartSection = tempDiv.querySelector('#cart-section');

      blocksToRender.forEach(block => {
        const blockElement = newCartSection.querySelector(`[${block}]`);
        if (blockElement) {
          cartSection.querySelector(`[${block}]`).outerHTML = blockElement.outerHTML;
        }
      });
    } else {
      console.error('Cart section element not found in DOM');
    }
  }

  document.addEventListener('cart:updateCart', (ev) => {
    console.log("cart:updateCart", ev.detail.responce);
    sectionId = () => {
      for(const key in ev.detail.responce.sections) {
        if(key.includes("__main-cart")) {
          return key;
        }

      }
      return null;
    }
    renderCart(sectionId(), ev.detail.responce);
  });

  } catch(e) { console.error(e); }
})();
})();
